import React from 'react';
import { CoreLink } from '@uncinc/react-drupal-core';

import {
  Image,
} from '@uncinc/uncinc-react-kitchen-sink';

import WysiwygField from '../../WysiwygField';

import './style.scss';

const Qoute = ({ body, imageSrc, imageAlt = '', name, jobTitle, link, linkTitle }) => {

  return (
    <div className="Quote">
      <div className="Quote__container">
        <div className="icon icon-quote icon-variant-1" />
      </div>
      <div className="Quote__content">
        <WysiwygField
          property="schema:text"
          className="Quote__body subheading2"
          html={body}
        />
        <div className="Quote__info">
          <div className="Quote__author">
            {imageSrc && <Image className="Quote__image" src={imageSrc} alt={imageAlt} />}
            <div>
              <div className="Quote__author__name">
                <h3>{name}</h3>
              </div>
              <div className="Quote__author__jobTitle">
                {jobTitle}
              </div>
            </div>
          </div>
          {link && linkTitle && (
            <div className="Quote__link">
              <CoreLink to={link}>
                {linkTitle}
                <div className="icon icon-chevron-right" />
              </CoreLink>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Qoute;
